<form role="form" [class]="submitType === 'toolbar' ? 'form-toolbar' : ''" novalidate [formGroup]="form">
	<formly-form *ngIf="formDefinition" [model]="model" [fields]="formDefinition.definition" [form]="form">
		<ion-button *ngIf="!readOnly && (!submitType || submitType === 'button')" type="submit"
			(click)="customSubmit(model, dataSource.databaseId, formDefinition.onSubmitAction)" class="btn btn-default">
			{{formDefinition.submitButtonText}}
		</ion-button>
	</formly-form>
</form>